// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  production: false,
  pageUrl: "https://wwwdev.sbdofe.ford.com",
  baseUri: "api-dev.service.ford.com/sbdobe",
  baseUrl: "https://api-dev.service.ford.com/sbdobe/",
  baseUrl1: "https://api-dev.service.ford.com/sbdobe/sbdo/",
  idsUrl: "https://api-dev.service.ford.com/ids/",
  automatedUrl: "https://api-dev.service.ford.com/teautomation/",
  rapUrl: "https://wwwqa.rap.fordtechservice.dealerconnection.com/RAP/api/SBDOWebAPI/",
  ptsUrl: "https://wwwdev.fordtechservice.dealerconnection.com/",
  schUrl: "https://api-dev.service.ford.com/sbdotescheduler/",
  gtacUrl: "https://www.gtacng.dealerconnection.com/tsr-submit?"

};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
